var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnCopy = function SvgIcnCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 6.66602H8.33341C7.41294 6.66602 6.66675 7.41221 6.66675 8.33268V14.9993C6.66675 15.9198 7.41294 16.666 8.33341 16.666H15.0001C15.9206 16.666 16.6667 15.9198 16.6667 14.9993V8.33268C16.6667 7.41221 15.9206 6.66602 15.0001 6.66602Z",
    stroke: "currentcolor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66732V5.00065C13.3333 4.55862 13.1577 4.1347 12.8451 3.82214C12.5325 3.50958 12.1086 3.33398 11.6666 3.33398H4.99992C4.55789 3.33398 4.13397 3.50958 3.82141 3.82214C3.50885 4.1347 3.33325 4.55862 3.33325 5.00065V11.6673C3.33325 12.1093 3.50885 12.5333 3.82141 12.8458C4.13397 13.1584 4.55789 13.334 4.99992 13.334H6.66659",
    stroke: "currentcolor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_copy.bbe8ebad.svg";
export { ForwardRef as ReactComponent };